import React from 'react'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'

export type Props = {
  label: string
  checked: boolean
  alreadyAdded: boolean
  onToggle: () => void
  testId: string
}

export const AddRequiredFieldOption = ({
  label,
  checked,
  alreadyAdded,
  onToggle,
  testId,
}: Props) => (
  <FormControlLabel
    labelPlacement="end"
    label={
      <Typography variant="body2">
        {alreadyAdded ? `${label} (already added)` : label}
      </Typography>
    }
    sx={{ marginBottom: 0, marginRight: 0 }}
    data-test-id={testId}
    control={
      <Checkbox
        onChange={onToggle}
        checked={alreadyAdded || checked}
        disabled={alreadyAdded}
        color="primary"
        size="small"
      />
    }
  />
)

AddRequiredFieldOption.displayName = 'AddRequiredFieldOption'
